<template>
  <div id="modal-screens">
    <b-modal ref="modal-slides" id="modal-slides" hide-footer hide-header size="xl">
      <div>
        <div class="left-icon-svg">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <path
              d="M38.334,31.667v-30A1.574,1.574,0,0,1,40,0V33.333A1.574,1.574,0,0,1,38.334,31.667ZM0,0A1.575,1.575,0,0,1,1.667,1.667v30A1.575,1.575,0,0,1,0,33.333ZM33.333,28.333V5A1.574,1.574,0,0,1,35,3.334V30A1.574,1.574,0,0,1,33.333,28.333ZM5,3.334A1.574,1.574,0,0,1,6.666,5V28.333A1.574,1.574,0,0,1,5,30Zm6.666,23.333A1.578,1.578,0,0,1,10,25V8.333a1.578,1.578,0,0,1,1.667-1.667H28.333A1.578,1.578,0,0,1,30,8.333V25a1.578,1.578,0,0,1-1.667,1.667Zm1.667-3.333H26.667V10H13.333Z"
              transform="translate(0 3)"
              fill="#88898d"
            />
          </svg>
        </div>
        <div class="right-icon-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            id="x-btn"
            v-on:click="closeScreens()"
          >
            <path
              d="M.42,2.49A1.486,1.486,0,0,1,.42.42a1.486,1.486,0,0,1,2.07,0L14.911,12.862,27.353.42A1.456,1.456,0,1,1,29.4,2.49L16.981,14.912,29.4,27.354a1.456,1.456,0,1,1-2.049,2.07L14.911,16.982,2.49,29.424a1.486,1.486,0,0,1-2.07,0,1.486,1.486,0,0,1,0-2.07L12.841,14.912Z"
              transform="translate(5.003 5)"
              fill="#D9D9DC"
            />
          </svg>
        </div>
      </div>
      <div class="img-in">
        <div class="image-wrapper-one">
          <img class="showScreen" :src="currentShot" />
        </div>
      </div>
      <div class="slides-carousel">
        <carousel
          :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
          navigation-prev-label="<span><img  style='
          width: 1.5em;
        ' src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
          navigation-next-label="<span><img style='
          width: 1.5em;
        ' src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
          :navigation-enabled="true"
          :pagination-enabled="false"
        >
          <slide v-for="item in getScreens()" :key="item.uid" class="slideForImg">
            <div class="slide-image-wrapper">
              <!--- img 16/9 -->
              <img
                :src="item.screenShot ? item.screenShot : screenShot"
                v-on:mouseover="showThis(item)"
              />
            </div>
          </slide>
        </carousel>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { Carousel, Slide } from 'vue-carousel';
  import Card from './Card.vue';

  export default {
    name: 'screenInSegment',
    props: {
      current: Object,
    },
    data() {
      return {
        screenShot:
          'data:image/png;base64,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',
        currentShot: '',
        exist: false,
      };
    },
    components: {
      Carousel,
      Slide,
      'card-segment': Card,
    },
    computed: {
      ...mapGetters({
        currentSegment: 'segments/getCurrent',
      }),
    },
    watch: {
      currentSegment(val) {
        if (val) {
          if (val.screens[0].screenShot === null || val.screens[0].screenShot === '')
            this.currentShot = this.screenShot;
          else this.currentShot = val.screens[0].screenShot;
        }
      },
    },
    mounted() {
      if (
        this.currentSegment &&
        this.currentSegment.screens !== undefined &&
        this.currentSegment.screens.length > 1
      ) {
        let firstScreen = this.currentSegment.screens[0].screenShot;
        this.currentShot = firstScreen ? firstScreen : this.screenShot;
      }
    },
    methods: {
      showThis(item) {
        this.currentShot = item.screenShot ? item.screenShot : this.screenShot;
      },
      getScreens() {
        if (this.currentSegment && this.currentSegment.screens !== undefined) {
          this.exist = true;
          let screens = this.currentSegment.screens;
          return screens && screens.filter(s => !s.type.toLowerCase().includes('generic'));
        }
      },
      closeScreens() {
        this.$root.$emit('bv::hide::modal', 'modal-slides', '#x-btn');
      },
    },
  };
</script>

<style lang="scss">
  .showScreen {
    width: 40em;
  }
  .img-in {
    //width: 50em;
    margin-bottom: 0;
    margin-top: 5em;
    display: inline-block;
    width: 100%;
    max-width: 50%;
  }
  .right-icon-svg {
    right: 1%;
    position: absolute;
    :hover {
      cursor: pointer;
    }
  }
  .left-icon-svg {
    margin: 1em;
    position: absolute;
  }
  #modal-screens .modal-content {
    background-color: rgba(0, 0, 0, 0.4);
    height: 98vh;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #bebebe;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background: #bebebe;
      border-radius: 5px;
      &:hover {
        background: #b2b2b2;
        height: 10px;
      }
    }
  }
  #modal-screens .modal-xl {
    max-width: 100% !important;
  }
  #modal-slides .modal-dialog {
    width: auto !important;
    margin: 0.75rem !important;
  }
  .screen {
    max-width: 250px;
  }
  #modal-screens .VueCarousel-navigation-button:focus {
    outline: none !important;
  }
  #modal-screens .VueCarousel-slide {
    visibility: visible;
    flex-basis: 100%;
    width: 100%;
  }
  //0 left 1 center
  .VueCarousel-slide {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
  }

  #modal-screens .slide {
    margin: 5px !important;
    max-width: 223px;
  }
  .VueCarousel-navigation .VueCarousel-navigation-button :focus {
    outline: none !important;
  }

  .screenSelected {
    border: solid;
    border-color: #007bff8c;
  }
  #modal-screens {
    text-align: center !important;
  }
  .slideForImg {
    max-width: 300px;
    margin: 1em;
    :hover {
      border: 2px solid #007bff8c !important;
      border-radius: 4px;
      cursor: pointer;
    }
  }

  .slide-image-wrapper {
    position: relative;
    padding-bottom: 56.2%;
  }

  .slide-image-wrapper img {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    left: 0%;
  }

  .container-one-img {
    max-width: 300px;
  }

  .image-wrapper-one {
    position: relative;
    padding-bottom: 56.2%;
  }

  .image-wrapper-one img {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    left: 0;
  }
  .slides-carousel {
    margin: 3em;
  }
</style>



// WEBPACK FOOTER //
// screenInSegment.vue?29a282ed